import { render, staticRenderFns } from "./stepsSelBank.vue?vue&type=template&id=ec123f26&scoped=true&"
import script from "./stepsSelBank.vue?vue&type=script&lang=ts&"
export * from "./stepsSelBank.vue?vue&type=script&lang=ts&"
import style0 from "./stepsSelBank.vue?vue&type=style&index=0&id=ec123f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec123f26",
  null
  
)

export default component.exports